import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, CalendarIcon } from 'lucide-react';
export function WhoWeAre() {
  return <section className="bg-white px-4 pb-[50px] pt-[50px]" data-id="element-245" data-mp="2ugz5sihk5ch">
      <div className="mx-auto max-w-6xl" data-id="element-246" data-mp="gmwue755az2u">
        <div className="grid grid-cols-1 items-stretch gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-247" data-mp="gllskcv9g1ed">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="relative min-h-[320px]" data-id="element-248" data-mp="clbo54n49j1m">
            <img src="https://cdn.magicpatterns.com/uploads/ccFqes8xWYKKAU2CdnvXty/6.18.24Used-DSC_0932.jpg" alt="Lancer Service customer waiting area with lounge seating, water cooler, and framed patent prints" className="h-full w-full rounded-2xl object-cover shadow-2xl shadow-black/20" data-id="element-249" data-mp="3p4jj45pqn2u0" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="space-y-6" data-id="element-250" data-mp="1804pyaxt7cfm">
            <span className="block text-sm font-bold uppercase tracking-widest text-brand-accent" data-id="element-251" data-mp="uaazjo6nok3s">
              YOUR ST. PAUL AUTO REPAIR SHOP
            </span>
            <h2 className="font-heading text-[30px] font-extrabold uppercase tracking-wide text-brand-dark" data-id="element-252" data-mp="z2lz2pxhi3vt">
              THE SHOP YOU COME BACK TO.
            </h2>
            <div className="space-y-5 text-lg leading-relaxed text-gray-700 md:text-xl" data-id="element-253" data-mp="6jyhvlllz900">
              <p className="text-[18px]" data-id="element-254" data-mp="3uowrg9jurj5y">
                Most people find us for one thing — an oil change, a tire
                rotation, something that needed to get done. Then they see how
                we work. The inspection report on their phone. The estimate
                before anyone touches anything. The technician who tells them
                their brakes are fine and they don&apos;t need to spend money
                today.
              </p>
              <p className="text-[18px] text-[#8E6340] font-[800]" data-id="element-255" data-mp="3bsdq46faizjy">
                That&apos;s when they stop shopping around.
              </p>
              <p className="text-[18px]" data-id="element-256" data-mp="3lprv99vrk1wy">
                We work on all makes and models — including hybrids and EVs.
                Whether you need a quick oil service for your family car or a
                complete maintenance plan for your high-mileage truck, we can
                help keep you on the road.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-4 pt-2 sm:grid-cols-2" data-id="element-257" data-mp="w1sjohtot7gj">
              <div className="flex items-center gap-3 rounded-2xl border border-gray-200 bg-brand-light p-4 shadow-sm" data-id="element-258" data-mp="2dvq980l54nae">
                <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-brand-accent/15" data-id="element-259" data-mp="2itrt2nqe4qmx">
                  <CalendarIcon className="h-5 w-5 text-brand-accent" data-id="element-260" data-mp="29v6awtotzdmo" />
                </div>
                <div data-id="element-261" data-mp="2xlagh6lkxngb">
                  <p className="font-heading text-xs font-bold uppercase tracking-wide text-gray-500" data-id="element-262" data-mp="2xksctowl86yd">
                    Established
                  </p>
                  <p className="font-bold text-brand-dark" data-id="element-263" data-mp="31ogke7l7z2jm">Since 1977</p>
                </div>
              </div>
              <div className="flex items-center gap-3 rounded-2xl border border-gray-200 bg-brand-light p-4 shadow-sm" data-id="element-264" data-mp="2subxfz97ib9d">
                <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-brand-accent/15" data-id="element-265" data-mp="3gjd2dcitz49w">
                  <MapPinIcon className="h-5 w-5 text-brand-accent" data-id="element-266" data-mp="3lbek3dyrpn7b" />
                </div>
                <div data-id="element-267" data-mp="1wpv0wj4dvbrw">
                  <p className="font-heading text-xs font-bold uppercase tracking-wide text-gray-500" data-id="element-268" data-mp="1wqd64590x0by">
                    Shop location
                  </p>
                  <a href="https://google.com/maps?um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KbmDlI9Q1feHMfLJfRWdix_1&daddr=270+E+8th+St,+St+Paul,+MN+55101" target="_blank" rel="noopener noreferrer" className="font-bold text-brand-dark transition-colors hover:text-brand-accent" data-id="element-269" data-mp="1nnlspzwl7uho">
                    270 E 8th St.
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}